var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-progress-component"},[_c('div',{ref:"line",staticClass:"progress-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }